<div class="w-full h-full" #mainDiv>
  <div id="globalMap"></div>
  <div class="map-overlay" *ngIf="mapIsLoading" [@fadeInOut]>
    <div class="flex justify-content-center align-items-center h-full">
      <div class="lds-dual-ring"></div>
    </div>
  </div>
  <p-sidebar
    [(visible)]="displayDetails"
    [appendTo]="mainDiv"
    [modal]="false"
    class="custom-sidebar"
    [styleClass]="detailsMode === 'asset' ? 'no-overflow-sidebar h-full lg:h-30rem custom-sidebar' : 'h-full lg:h-25rem custom-sidebar'"
    position="bottom"
  >
    <app-map-asset-details
      *ngIf="detailsMode === 'asset'"
      class="h-full"
      [hashedMapAsset]="hashedMapAsset"
      [assetUuid]="assetDetailsUuid"
      (assetChangedStatus)="updateAssetStatus($event)"
    ></app-map-asset-details>
    <app-map-cluster-details
      *ngIf="detailsMode === 'cluster'"
      [assetUuids]="assetDetailsUuids"
      [hashedMapAsset]="hashedMapAsset"
      (onAssetSelected)="showAssetDetails($event, null); detailsMode='asset'"
    ></app-map-cluster-details>
  </p-sidebar>
</div>
<div class="hidden">
  <div class="mapboxgl-ctrl mapboxgl-ctrl-group" id="map-layer-control">
    <button
      [style.border-radius]="'4px'"
      [style.backgroundColor]="filtersVisible ? 'gray' : 'white'"
      [style.color]="filtersVisible ? 'white' : 'black'"
      (click)="toggleFilters(); displayDetails=false"
      pRipple
      class="hover:bg-black-alpha-{{filtersVisible ? '40' : '10'}}"
      type="button"
    >
      <i class="pi pi-filter" style="font-size: 16px;"></i>
    </button>
  </div>
</div>

<app-map-filter-details
  (mapDataChanged)="mapDataFiltered = $event"
  [hidden]="!filtersVisible"
  [representationVisibility]="representationVisibility"
  [possibleStatus]="possibleStatus"
  [map]="map"
  [mapData]="mapData"
  [uniqueMapAssetRepresentations]="uniqueMapAssetRepresentations"
  style="background-color: #ffffff"
></app-map-filter-details>
